<div class="tenancy-reconcile">
  <app-title-bar
    title="Tenancy Reconcile"
    description="Shop-scoped company_id coverage across tenant tables. Clean means every row that can resolve an owner company has a matching company_id."
  >
    <ng-template #buttonContent>
      <button
        type="button"
        class="btn btn-outlined btn-medium"
        [disabled]="loading || backfilling"
        (click)="refresh()"
      >
        {{ loading ? 'Refreshing…' : 'Refresh' }}
      </button>
    </ng-template>
  </app-title-bar>

  <app-loading-table-shimmer
    *ngIf="loading"
    [columns]="shimmerColumns"
    [rows]="8"
  ></app-loading-table-shimmer>

  <app-empty-result
    *ngIf="showEmptyState"
    [title]="'Unable to load reconcile'"
    [description]="errorMessage"
    [showAction]="true"
    [actionText]="'Retry'"
    (actionClicked)="refresh()"
  ></app-empty-result>

  <app-empty-result
    *ngIf="showPayloadEmpty"
    [title]="'No reconcile data'"
    [description]="'The API returned no tenancy reconcile payload.'"
    [showAction]="true"
    [actionText]="'Retry'"
    (actionClicked)="refresh()"
  ></app-empty-result>

  <ng-container *ngIf="!loading && !showEmptyState && !showPayloadEmpty">
    <div class="tenancy-reconcile__meta" *ngIf="checkedAt">
      Checked {{ checkedAt | date: 'medium' }}
    </div>

    <div
      class="tenancy-reconcile__banner tenancy-reconcile__banner--ok"
      *ngIf="isClean === true"
      role="status"
    >
      Reconcile is clean.
    </div>

    <div class="tenancy-reconcile__sticky" *ngIf="isClean === false">
      <div class="tenancy-reconcile__banner tenancy-reconcile__banner--warn">
        <div class="tenancy-reconcile__banner-main">
          <p class="tenancy-reconcile__banner-title">Reconcile is not clean</p>
          <p class="tenancy-reconcile__banner-body">
            Re-run the idempotent tenant backfill to fill null
            <code>company_id</code> where an owner company can be derived.
          </p>
          <p class="tenancy-reconcile__summary-count" *ngIf="issues.length > 0">
            {{ issueSummary }}
          </p>
        </div>

        <div class="tenancy-reconcile__banner-aside">
          <div class="tenancy-reconcile__issue-controls" *ngIf="issues.length > 0">
            <span>Issue {{ activeIssueIndex + 1 }} of {{ issues.length }}</span>
            <button
              type="button"
              class="btn btn-outlined btn-small"
              aria-label="Previous issue"
              (click)="previousIssue()"
            >
              <img
                class="tenancy-reconcile__chevron"
                src="/assets/images/sidebar/chevron-left.svg"
                alt=""
                width="16"
                height="16"
              />
            </button>
            <button
              type="button"
              class="btn btn-outlined btn-small"
              aria-label="Next issue"
              (click)="nextIssue()"
            >
              <img
                class="tenancy-reconcile__chevron tenancy-reconcile__chevron--next"
                src="/assets/images/sidebar/chevron-left.svg"
                alt=""
                width="16"
                height="16"
              />
            </button>
          </div>
          <button
            type="button"
            class="btn btn-primary btn-medium"
            [disabled]="backfilling"
            (click)="runBackfill()"
          >
            {{ backfilling ? 'Running…' : 'Run backfill' }}
          </button>
        </div>
      </div>
    </div>

    <div class="tenancy-reconcile__message" *ngIf="backfillMessage" role="status">
      {{ backfillMessage }}
    </div>

    <div class="tenancy-reconcile__error" *ngIf="errorMessage" role="alert">
      {{ errorMessage }}
    </div>

    <pre class="tenancy-reconcile__json" *ngIf="jsonLines.length > 0"><code><span
      *ngFor="let line of jsonLines"
      #jsonIssue
      [attr.data-issue-index]="line.issueIndex"
      [class.tenancy-reconcile__json-line--issue]="line.issueIndex !== null"
      [class.tenancy-reconcile__json-line--active]="line.issueIndex === activeIssueIndex"
    >{{ line.content }}
</span></code></pre>
  </ng-container>
</div>
